import React, { useEffect } from "react";
import newLogo from "../../assets/new_logo.png";
import amsComtel from "../../assets/ams.png";
import { DatePicker, Form, Select, message } from "antd";
import { useState } from "react";
import AxiosInstance from "../../AxiosInstance";
import { Option } from "antd/es/mentions";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import { Input, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import { LDMSRequestType } from "../../constants";
const { Search } = Input;

export default function Ldms() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    setValue,
  } = useForm({ mode: "onChange" });
  const [businessPartner, setBusinessPartner] = useState([]);
  const [productList, setProductList] = useState([]);
  const [policyData, setPolicyData] = useState({});
  const [insurerList, setInsurerList] = useState({});
  const [loading, setLoading] = useState(false);
  const [maxId, setMaxId] = useState();
  //   const getBusinessPartner = () => {};
  const getBusinessPartner = (id) => {
    const url = `/misc/businessPartner/${id}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        setBusinessPartner(data);
      });
  };
  const getProductList = (id) => {
    const url = `/misc/product/${id}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        setProductList(data);
      });
  };
  const getPolicyData = (policyNumber) => {
    if (!policyNumber) {
      message.error("Policy Number is Required");
      return;
    }
    setLoading(true);
    const url = `/lead/getPolicyFromInsurer/${policyNumber}/15`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        // setProductList(data);
        console.log(data);
        setPolicyData(data);
        setValue("name", data.name);
        setValue("phoneNumber", data.phoneNumber);
        setValue("email", data.email);
        setValue("policyIssueDate", moment(data.policyIssueDate));
        setValue("policyAnnualPremium", data.policyAnnualPremium);
        setValue("policySurrenderValue", parseInt(data.policySurrenderValue));
        setValue("policyDueDate", moment(data.policyDueDate));
        setValue("policyPremiumPending", data.policyPremiumPending);
        setValue("planNameIc", data.planNameIc);

        setLoading(false);
      })
      .catch((error) => {
        message.error(error.response.data.message);
        setLoading(false);
      });
  };
  const getInsurerList = () => {
    const url = `/misc/insurerList`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        // setProductList(data);
        console.log(data);
        setInsurerList(data);
        let id = data.find(
          (insurer) => insurer.name === "Axis Max Life Insurance Co. Ltd."
        ).insurerId;
        getBusinessPartner(id);
        // getProductList(id);
        setMaxId(id);
      });
  };
  useEffect(() => {
    setValue("leadType", "ASSIGNMENT");
    setValue("shouldFetchFromInsurer", true);
    getInsurerList();
  }, []);
  const businessPartnerChange = (businessPartnerId) => {
    errors.businessPartnerId = false;
    setValue("businessPartnerId", businessPartnerId);
  };
  const leadTypeChange = (leadTypeId) => {
    errors.leadType = false;
    setValue("leadType", leadTypeId);
  };
  const shouldFetchFromInsurerChange = (value) => {
    errors.shouldFetchFromInsurer = false;
    setValue("shouldFetchFromInsurer", value);
  };

  const planChange = (productId) => {
    errors.productId = false;
    setValue("productId", productId);
  };
  const issueDateChange = (_, dateString) => {
    errors.policyIssueDate = false;
    setValue("policyIssueDate", dateString);
  };

  const dueDateChange = (_, dateString) => {
    errors.policyDueDate = false;
    setValue("policyDueDate", dateString);
  };
  const onSubmit = (value) => {
    console.log(value);
    const payload = {
      // name: value?.name,
      countryCode: "+91",
      // phoneNumber: value?.phoneNumber,
      role: "POLICY_MASTER",
      source: "INSURER",
      referralCode: value?.referralCode,
      partnerName: value?.partnerName,
      remarks: value?.remarks,
      // email: value?.email,
      policyNumber: value?.policyNumber,
      planNameIc: value?.planNameIc,
      insurerId: maxId,
      businessPartnerId: value?.businessPartnerId,
      referrerId: value?.referrerId,
      employeeContactNo: value?.employeeContactNo,
      officeCode: value?.officeCode,
      // policyAnnualPremium: value?.policyAnnualPremium,
      // policySurrenderValue: value?.policySurrenderValue,
      // policyPremiumPending: value?.policyPremiumPending,
      // policyIssueDate: value.policyIssueDate
      //   ? value.policyIssueDate.format("YYYY-MM-DD")
      //   : null,
      // policyDueDate: value.policyDueDate
      //   ? value.policyDueDate.format("YYYY-MM-DD")
      //   : null,
      shouldFetchFromInsurer: value.shouldFetchFromInsurer,
      leadDate: moment().format("YYYY-MM-DD"),
      leadType: value.leadType,
    };
    console.log("payload", payload);
    const url = `/lead/insurer`;
    AxiosInstance()
      .post(url, payload)
      .then((resp) => {
        let { data } = resp;
        message.success("form submitted successfully");
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };
  const onChange = (e) => {
    setValue("remarks", e.target.value);
  };
  return (
    <div>
      <div className="website-header d-flex justify-content-between">
        <img className="" src={newLogo} height={75} alt="logo-login" />
        <h3 className="m-3">
          <b>Lead &nbsp;Management&nbsp; System</b>
        </h3>
        <div className="d-flex flex-row">
          {/* <img className="" src={newLogo} height={60} alt="logo-login" /> */}
        </div>
      </div>
      <div className="mt-5 d-flex justify-content-center">
        <form
          className="mt-0 mt-md-5"
          id="leadForm"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Form
            labelAlign="left"
            labelCol={{
              span: 10,
            }}
            wrapperCol={{
              span: 14,
            }}
            layout="horizontal"
            //   disabled={componentDisabled}
            // style={{
            //   minWidth: 600,
            // }}
          >
            <div className="container">
              <div className="row gx-5">
                <div className="col-sm-12  col-md-6 ">
                  {" "}
                  <Form.Item label="Policy Number">
                    <Controller
                      name="policyNumber"
                      control={control}
                      errors={errors}
                      rules={{ required: true }}
                      render={(props) => (
                        <Search
                          id="policyNumber"
                          // placeholder="Enter Policy Number"
                          onChange={(change) =>
                            setValue("policyNumber", change.target.value)
                          }
                          className={` ${
                            errors.policyNumber ? " is-invalid" : ""
                          }`}
                          // {...register("policyNumber", {
                          //   // required: true,
                          //   pattern: {
                          //     value: /^[0-9]*$/i,

                          //     message: "only numbers allowed",
                          //   },
                          // })}
                          onSearch={getPolicyData}
                          // onSearch={onSearch}
                          style={{
                            width: 200,
                            height: 30,
                          }}
                          loading={loading}
                        />
                      )}
                    />

                    <div className="invalid-feedback">
                      {errors?.policyNumber?.message}
                    </div>
                  </Form.Item>
                  <Form.Item
                    // tooltip="This is a required field"
                    className="mb-5"
                    label={
                      <>
                        Business Partner{" "}
                        {<span style={{ color: "red" }}>*</span>}
                      </>
                    }
                  >
                    <div>
                      {" "}
                      <Controller
                        name="businessPartnerId"
                        control={control}
                        errors={errors}
                        rules={{ required: true }}
                        render={(props) => (
                          <Select
                            placeholder="Select Partner"
                            onChange={businessPartnerChange}
                            className={`${
                              errors.businessPartnerId ? "is-invalid" : ""
                            }`}
                          >
                            {businessPartner.map((item) => (
                              <Option
                                key={item.businessPartnerId}
                                value={item.businessPartnerId}
                              >
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      />
                      <div className="invalid-feedback">
                        Business Partner is required
                      </div>
                    </div>
                  </Form.Item>
                  <Form.Item
                    label={
                      <>
                        Customer Name{<span style={{ color: "red" }}>*</span>}
                      </>
                    }
                    // tooltip="This is a required field"
                  >
                    <input
                      id="name"
                      disabled
                      // placeholder="Enter Customer Name"
                      className={`form-control ${
                        errors.name ? " is-invalid" : ""
                      }`}
                      {...register("name", {
                        required: {
                          value: true,
                          message: "name is required",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.name?.message}
                    </div>
                  </Form.Item>
                  <Form.Item
                    label={
                      <>
                        Contact Number{<span style={{ color: "red" }}>*</span>}
                      </>
                    }
                    // tooltip="This is a required field"
                  >
                    <input
                      id="phoneNumber"
                      // placeholder="Enter Contact Number"
                      maxLength={10}
                      disabled
                      className={`form-control ${
                        errors.phoneNumber ? " is-invalid" : ""
                      }`}
                      {...register("phoneNumber", {
                        required: {
                          value: true,
                          message: "phone number is required",
                        },
                        // pattern: {
                        //   value: /^[6789]\d{9}$/,

                        //   message: "enter valid number",
                        // },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.phoneNumber?.message}
                    </div>
                  </Form.Item>
                  <Form.Item label="Issue Date">
                    <div className="input-group pb-2 position-relative">
                      {" "}
                      <Controller
                        name="policyIssueDate"
                        control={control}
                        errors={errors}
                        render={(props) => {
                          return (
                            <DatePicker
                              style={{ width: 210 }}
                              // defaultValue={null}
                              value={props.field.value}
                              disabled
                              disabledDate={(current) => {
                                return (
                                  current && current > moment().add(0, "month")
                                );
                              }}
                              onChange={issueDateChange}
                            />
                          );
                        }}
                      />
                    </div>
                  </Form.Item>
                  <Form.Item label="Due Date" className="mb-5">
                    <Controller
                      name="policyDueDate"
                      control={control}
                      errors={errors}
                      render={(props) => (
                        <DatePicker
                          style={{ width: 195 }}
                          value={props.field.value}
                          disabled
                          onChange={dueDateChange}
                        />
                      )}
                    />
                  </Form.Item>
                  <Form.Item label="Agent Name">
                    <input
                      id="partnerName"
                      // placeholder="Enter Agent Name"
                      className={`form-control ${
                        errors.partnerName ? " is-invalid" : ""
                      }`}
                      {...register("partnerName", {
                        // required: true,
                      })}
                    />
                  </Form.Item>
                  <Form.Item label="Agent Code">
                    <input
                      id="referralCode"
                      // placeholder="Enter Agent Code"
                      className={`form-control ${
                        errors.referralCode ? " is-invalid" : ""
                      }`}
                      {...register("referralCode", {
                        // required: true,
                      })}
                    />
                  </Form.Item>
                  <Form.Item label="Office Code">
                    <input
                      id="officeCode"
                      // placeholder="Enter Agent Code"
                      className={`form-control ${
                        errors.officeCode ? " is-invalid" : ""
                      }`}
                      {...register("officeCode", {
                        // required: true,
                      })}
                    />
                  </Form.Item>
                  <Form.Item label="Agent Contact">
                    <input
                      id="employeeContactNo"
                      // placeholder="Enter Agent Code"
                      className={`form-control ${
                        errors.employeeContactNo ? " is-invalid" : ""
                      }`}
                      {...register("employeeContactNo", {
                        // required: true,
                      })}
                    />
                  </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6">
                  <Form.Item label="Lead Date">
                    <Controller
                      name="leadDate"
                      control={control}
                      errors={errors}
                      render={(props) => (
                        <DatePicker
                          style={{ width: 195, color: "black" }}
                          disabled
                          defaultValue={moment()}
                        />
                      )}
                    />
                  </Form.Item>
                  <Form.Item
                    // tooltip="This is a required field"
                    className="mb-5"
                    label={
                      <>
                        Fetch from Insurer{" "}
                        {<span style={{ color: "red" }}>*</span>}
                      </>
                    }
                  >
                    <div>
                      {" "}
                      <Controller
                        name="shouldFetchFromInsurer"
                        control={control}
                        errors={errors}
                        rules={{ required: true }}
                        render={(props) => (
                          <Select
                            placeholder="Select Type"
                            onChange={shouldFetchFromInsurerChange}
                            className={`${
                              errors.shouldFetchFromInsurer ? "is-invalid" : ""
                            }`}
                            defaultValue={true}
                          >
                            <Option key={"false"} value={false}>
                              {"No"}
                            </Option>
                            <Option key={"true"} value={true}>
                              {"Yes"}
                            </Option>
                          </Select>
                        )}
                      />
                      <div className="invalid-feedback">
                        Fetch from Insurer is required
                      </div>
                    </div>
                  </Form.Item>
                  <Form.Item
                    className="mb-5"
                    label={
                      <>Plan Name IC{<span style={{ color: "red" }}>*</span>}</>
                    }
                    // tooltip="This is a required field"
                  >
                    <input
                      id="planNameIc"
                      disabled
                      // placeholder="Enter Customer Name"
                      style={{ fontSize: 10 }}
                      className={`form-control ${
                        errors.planNameIc ? " is-invalid" : ""
                      }`}
                      {...register("planNameIc", {
                        required: {
                          value: true,
                          message: "planNameIc is required",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.planNameIc?.message}
                    </div>
                  </Form.Item>

                  {/* <Form.Item
                    // tooltip="This is a required field"
                    className="mb-5"
                    label="Plan Name"
                  >
                    <div>
                      {" "}
                      <Controller
                        name="productId"
                        control={control}
                        errors={errors}
                        // rules={{ required: true }}
                        render={(props) => (
                          <Select
                            placeholder="Select Plan"
                            onChange={planChange}
                            className={`${
                              errors.productId ? "is-invalid" : ""
                            }`}
                          >
                            {productList.map((item) => (
                              <Option
                                key={item.productId}
                                value={item.productId}
                              >
                                {item.productName}
                              </Option>
                            ))}
                          </Select>
                        )}
                      />
                      <div className="invalid-feedback">Plan is required</div>
                    </div>
                  </Form.Item> */}
                  <Form.Item label="Annual Premium">
                    <input
                      id="policyAnnualPremium"
                      disabled={policyData.policyAnnualPremium}
                      // placeholder="Enter Annual Premium"
                      className={`form-control ${
                        errors.policyAnnualPremium ? " is-invalid" : ""
                      }`}
                      {...register("policyAnnualPremium", {
                        // required: true,
                        // pattern: {
                        //   value: /^[0-9]*$/i,
                        //   message: "only numbers allowed",
                        // },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.policyAnnualPremium?.message}
                    </div>
                  </Form.Item>
                  <Form.Item label="Fund/Surrender Value">
                    <input
                      id="policySurrenderValue"
                      // placeholder="Enter Surrender Value"
                      className={`form-control ${
                        errors.policySurrenderValue ? " is-invalid" : ""
                      }`}
                      disabled={policyData.policySurrenderValue}
                      policySurrenderValue
                      {...register("policySurrenderValue", {
                        // required: true,
                        pattern: {
                          value: /^-?\d+(\.\d+)?$/i,

                          message: "only numbers allowed",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.policySurrenderValue?.message}
                    </div>
                  </Form.Item>
                  <Form.Item
                    label={<>Customer to Pay </>}
                    // style={{ marginBottom: "105px" }}
                  >
                    <input
                      id="policyPremiumPending"
                      // placeholder="Enter Pending Premium"
                      disabled={policyData.policyPremiumPending}
                      className={`form-control ${
                        errors.policyPremiumPending ? " is-invalid" : ""
                      }`}
                      {...register("policyPremiumPending", {
                        // required: true,
                        // pattern: {
                        //   value: /^-?\d+(\.\d+)?$/i,
                        //   message: "only numbers allowed",
                        // },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.policyPremiumPending?.message}
                    </div>
                  </Form.Item>
                  <Form.Item
                    // tooltip="This is a required field"
                    className="mb-5"
                    label={
                      <>
                        Request Type {<span style={{ color: "red" }}>*</span>}
                      </>
                    }
                  >
                    <div>
                      {" "}
                      <Controller
                        name="leadType"
                        control={control}
                        errors={errors}
                        rules={{ required: true }}
                        render={(props) => (
                          <Select
                            placeholder="Select Type"
                            onChange={leadTypeChange}
                            className={`${errors.leadType ? "is-invalid" : ""}`}
                            defaultValue={"ASSIGNMENT"}
                          >
                            {LDMSRequestType.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      />
                      <div className="invalid-feedback">
                        Lead Type is required
                      </div>
                    </div>
                  </Form.Item>
                  <Form.Item
                    label={<>Email</>}
                    // tooltip="This is a required field"
                  >
                    <input
                      id="email"
                      disabled
                      // placeholder="Enter Customer Name"
                      className={`form-control ${
                        errors.email ? " is-invalid" : ""
                      }`}
                      {...register("email", {
                        // required: {
                        //   value: true,
                        //   message: "name is required",
                        // },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.email?.message}
                    </div>
                  </Form.Item>
                  <Form.Item label="Remarks">
                    <TextArea rows={4} onChange={onChange} placeholder="" />
                  </Form.Item>
                </div>
              </div>
            </div>

            {/* <Form.Item className="d-flex justify-content-center"> */}
            <div className="d-flex justify-content-center">
              <button
                type="submit"
                className="normal-button  py-1"
                form="leadForm"
              >
                Submit
              </button>
            </div>
            {/* </Form.Item> */}
          </Form>
        </form>
      </div>
      {/* <div style={{ position: "fixed", right: "10px", bottom: "10px" }}>
        <img alt="Call Support" style={{ height: "30px" }} src={amsComtel} />
      </div> */}
    </div>
  );
}
